import { FormContainerStepProps } from 'components';
import { useTranslation } from 'libs/i18n';
import {
  ClientType,
  FormBodyWrapper,
} from 'modules/onboarding/common/components';

import {
  CompanyNameFormType,
  FormErrors,
  getSchema,
} from '../../forms/companyNameForm';

import { FormContent, FormContentProps } from './FormContent';

interface Props extends FormContentProps, FormContainerStepProps {
  initialValues?: CompanyNameFormType;
  onSubmit: (values: CompanyNameFormType) => void;
  canGoBack?: boolean;
  onGoBack?: () => void;
  formError?: FormErrors;
  submitLoading?: boolean;
  clientType?: ClientType;
}

export const CompanyName = ({
  initialValues,
  canGoBack,
  onGoBack,
  submitLoading,
  clientType,
  formError,
  onSubmit,
  step,
  ...formProps
}: Props) => {
  const { t } = useTranslation();
  const schema = getSchema();
  return (
    <FormBodyWrapper
      canGoBack={canGoBack}
      clientType={clientType}
      initialErrors={formError}
      initialValues={initialValues}
      step={step}
      submitLoading={submitLoading}
      subTitle={t('onboarding.companyName.subtitle')}
      title={t('onboarding.companyName.title')}
      validationSchema={schema}
      onGoBack={onGoBack}
      onSubmit={onSubmit}
    >
      <FormContent {...formProps} />
    </FormBodyWrapper>
  );
};
